export function showAlert (setDisplayAlert:(display:boolean)=>void, time:number) {
    setDisplayAlert(true)
    setTimeout(() => {
      setDisplayAlert(false);
    }, time);
  }